import React, { useContext } from 'react';
import Icon from '@vtblife/uikit-icons';
import WideContent from './wide-content';
import s from './header.module.css';
import { context } from '../utils';
var Header = function Header(_ref) {
  var children = _ref.children;
  var _useContext = useContext(context),
    close = _useContext.close,
    closable = _useContext.closable,
    dataTest = _useContext.dataTest;
  return React.createElement(WideContent, {
    header: true
  }, React.createElement("div", {
    className: s.box,
    "data-test": dataTest && "".concat(dataTest, "-header")
  }, React.createElement("div", {
    className: s.content
  }, children), closable && React.createElement("button", {
    className: s.close,
    onClick: close,
    "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    "data-test": dataTest && "".concat(dataTest, "-close")
  }, React.createElement(Icon, {
    name: "times",
    size: "s"
  }))));
};
export default Header;